import { FC } from 'react';
import { Box } from '../../../Box';

import styles from './index.module.css';

interface SliderRailProps {
  getRailProps: () => Record<string, unknown>;
}

export const SliderRail: FC<SliderRailProps> = ({ getRailProps }) => (
  <>
    <Box
      direction="column"
      className={styles.railOuterStyle}
      {...getRailProps()}
    />
    <Box className={styles.railInnerStyle} />
  </>
);
